export default __webpack_public_path__ + "static/principles-of-use-dont-66d9030e6e145da26440294b38d3b1d65e7fc5e2ede9019e9ab5408afcf09ea8.png";